import { JobSearchResultResponse } from '@doda/api-client/aspida/@types';
import { COOKIE } from '@doda/common/src/constants/cookie';
import { cookieHistoryIdFormat } from '@doda/common/src/logics/cookieHistoryIdFormat';
import { getHistoryList } from '@doda/common/src/services/getHistoryListAPI';
import { getCookie } from '@doda/common/src/utils/cookieUtil';
import {
  MAX_COUNT,
  NaviItem,
} from 'components/FollowSearchResultsNavigation/constants';
import { useState } from 'react';

interface ArgumentType {
  isOpenMenu: boolean;
  menuContents: number | null;
  onClickMenuOpen: (item: NaviItem) => void;
}

/**
 * 最近見た求人
 * @param param.isOpenMenu アコーディオンメニューが開いているかの判定フラグ
 * @param param.menuContents 表示するアコーディオンメニューの内容
 * @param param.onClickMenuOpen アコーディオンメニュー開閉のイベント処理
 * @returns 最近見た求人データと更新関数、メニュー表示時のイベント処理
 */
export const useHistoryJobs = ({
  isOpenMenu,
  menuContents,
  onClickMenuOpen,
}: ArgumentType) => {
  const [historyList, setHistoryList] = useState<JobSearchResultResponse[]>([]);

  const onClickHistory = async (item: NaviItem) => {
    if (!isOpenMenu || item.id !== menuContents) {
      await getCookieHistoryId();
    }
    onClickMenuOpen(item);
  };

  // cookieのHISTORYIDをもとに求人情報を取得
  const getCookieHistoryId = async () => {
    const cookieValue = getCookie(COOKIE.HISTORYID);
    if (!cookieValue) {
      setHistoryList([]);
      return;
    }
    const historyId = cookieHistoryIdFormat(cookieValue);
    // 閲覧日が新しい順で最大10件を抽出
    const targetHistoryId = historyId
      .map((item) => {
        return {
          id: item.id,
          date: Number(item.date),
          viewNum: item.viewNum,
        };
      })
      .sort((a, b) => b.date - a.date)
      .slice(0, MAX_COUNT);
    const jidList = targetHistoryId.map(({ id }) => id);
    const { results } = await getHistoryList(jidList);
    if (!results) {
      setHistoryList([]);
      return;
    }
    setHistoryList(results.reverse());
  };

  // 最近見た求人データの更新処理
  const updateHistoryList = (list: JobSearchResultResponse[]) => {
    setHistoryList(list);
  };

  return {
    historyList,
    updateHistoryList,
    onClickHistory,
  };
};
